module.exports = __webpack_public_path__ + "img/in-use-kati@1x.6156086e.jpg";